export function clearStuckPositionDragArtifacts() {
  document.querySelector("[data-position-department-drag-ghost]")?.remove();
  document.querySelector("[data-position-reorder-drop-indicator]")?.remove();
  document.querySelectorAll(".position-role-reorder-drag-source").forEach((el) => {
    el.classList.remove("position-role-reorder-drag-source");
  });
}
